import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SltDataServiceService {

  constructor(private http: HttpClient) { }

  /**
   * Test data service by calling the API with dynamic parameters
   * @param baseUrl - The base URL for API calls
   * @param inParams - Array of input parameters with key, value, and urlparam
   * @returns Observable with the API response
   */
  testDataService(baseUrl: string, inParams: any[]): Observable<any> {
    // Build query string from inParams array
    let paramsData = '';
    inParams.forEach(element => {
      if (element.urlparam && element.value !== undefined && element.value !== null) {
        paramsData += element.urlparam + "=" + encodeURIComponent(element.value) + "&";
      }
    });
    
    // Remove trailing '&'
    if (paramsData.length > 0) {
      paramsData = paramsData.substring(0, paramsData.length - 1);
    }
    
    // Build complete URL
    const url = `${baseUrl}/v1/dataservices/data/json?${paramsData}`;
    
    // Make GET request (following AngularJS pattern)
    return this.http.get<any>(url, { 
      withCredentials: true 
    });
  }
}

